import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    $('.toast').toast({ delay: 4000 }).toast('show')
  }
}
